// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AboutRouteImport } from './routes/about'
import { Route as BackToSchoolRouteImport } from './routes/back-to-school'
import { Route as BestSellersRouteImport } from './routes/best-sellers'
import { Route as CartRouteImport } from './routes/cart'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as ChristmasRouteImport } from './routes/christmas'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as DataRequestRouteImport } from './routes/data-request'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MrboxRouteImport } from './routes/mrbox'
import { Route as NewProductsRouteImport } from './routes/new-products'
import { Route as OffersRouteImport } from './routes/offers'
import { Route as PandakiRouteImport } from './routes/pandaki'
import { Route as PaymentMethodsRouteImport } from './routes/payment-methods'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ReturnsRouteImport } from './routes/returns'
import { Route as SearchRouteImport } from './routes/search'
import { Route as ShippingMethodsRouteImport } from './routes/shipping-methods'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as AuthenticatedAccountRouteImport } from './routes/_authenticated/account'
import { Route as AuthenticatedWishlistRouteImport } from './routes/_authenticated/wishlist'
import { Route as BrandIdRouteImport } from './routes/brand.$id'
import { Route as CSlugRouteImport } from './routes/c.$slug'
import { Route as DevGamesRouteImport } from './routes/dev.games'
import { Route as OrderTokenRouteImport } from './routes/order.$token'
import { Route as PSlugRouteImport } from './routes/p.$slug'
import { Route as PaymentFailureRouteImport } from './routes/payment.failure'
import { Route as PaymentSuccessRouteImport } from './routes/payment.success'
import { Route as AuthenticatedAccountIndexRouteImport } from './routes/_authenticated/account/index'
import { Route as AuthenticatedAccountAddressesRouteImport } from './routes/_authenticated/account/addresses'
import { Route as AuthenticatedAccountCouponsRouteImport } from './routes/_authenticated/account/coupons'
import { Route as AuthenticatedAccountOrdersRouteImport } from './routes/_authenticated/account/orders'
import { Route as AuthenticatedAccountPrivacyRouteImport } from './routes/_authenticated/account/privacy'
import { Route as AuthenticatedAccountReturnsRouteImport } from './routes/_authenticated/account/returns'
import { Route as AuthenticatedAccountSecurityRouteImport } from './routes/_authenticated/account/security'
import { Route as AuthenticatedAccountWishlistRouteImport } from './routes/_authenticated/account/wishlist'
import { Route as PSlugReviewRouteImport } from './routes/p.$slug.review'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRoute = AuthenticatedRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const BackToSchoolRoute = BackToSchoolRouteImport.update({
            id: '/back-to-school',path: '/back-to-school',getParentRoute: () => rootRouteImport
          })
const BestSellersRoute = BestSellersRouteImport.update({
            id: '/best-sellers',path: '/best-sellers',getParentRoute: () => rootRouteImport
          })
const CartRoute = CartRouteImport.update({
            id: '/cart',path: '/cart',getParentRoute: () => rootRouteImport
          })
const CheckoutRoute = CheckoutRouteImport.update({
            id: '/checkout',path: '/checkout',getParentRoute: () => rootRouteImport
          })
const ChristmasRoute = ChristmasRouteImport.update({
            id: '/christmas',path: '/christmas',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const DataRequestRoute = DataRequestRouteImport.update({
            id: '/data-request',path: '/data-request',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const MrboxRoute = MrboxRouteImport.update({
            id: '/mrbox',path: '/mrbox',getParentRoute: () => rootRouteImport
          })
const NewProductsRoute = NewProductsRouteImport.update({
            id: '/new-products',path: '/new-products',getParentRoute: () => rootRouteImport
          })
const OffersRoute = OffersRouteImport.update({
            id: '/offers',path: '/offers',getParentRoute: () => rootRouteImport
          })
const PandakiRoute = PandakiRouteImport.update({
            id: '/pandaki',path: '/pandaki',getParentRoute: () => rootRouteImport
          })
const PaymentMethodsRoute = PaymentMethodsRouteImport.update({
            id: '/payment-methods',path: '/payment-methods',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const ReturnsRoute = ReturnsRouteImport.update({
            id: '/returns',path: '/returns',getParentRoute: () => rootRouteImport
          })
const SearchRoute = SearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => rootRouteImport
          })
const ShippingMethodsRoute = ShippingMethodsRouteImport.update({
            id: '/shipping-methods',path: '/shipping-methods',getParentRoute: () => rootRouteImport
          })
const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAccountRoute = AuthenticatedAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedWishlistRoute = AuthenticatedWishlistRouteImport.update({
            id: '/wishlist',path: '/wishlist',getParentRoute: () => AuthenticatedRoute
          })
const BrandIdRoute = BrandIdRouteImport.update({
            id: '/brand/$id',path: '/brand/$id',getParentRoute: () => rootRouteImport
          })
const CSlugRoute = CSlugRouteImport.update({
            id: '/c/$slug',path: '/c/$slug',getParentRoute: () => rootRouteImport
          })
const DevGamesRoute = DevGamesRouteImport.update({
            id: '/dev/games',path: '/dev/games',getParentRoute: () => rootRouteImport
          })
const OrderTokenRoute = OrderTokenRouteImport.update({
            id: '/order/$token',path: '/order/$token',getParentRoute: () => rootRouteImport
          })
const PSlugRoute = PSlugRouteImport.update({
            id: '/p/$slug',path: '/p/$slug',getParentRoute: () => rootRouteImport
          })
const PaymentFailureRoute = PaymentFailureRouteImport.update({
            id: '/payment/failure',path: '/payment/failure',getParentRoute: () => rootRouteImport
          })
const PaymentSuccessRoute = PaymentSuccessRouteImport.update({
            id: '/payment/success',path: '/payment/success',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAccountIndexRoute = AuthenticatedAccountIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAccountRoute
          })
const AuthenticatedAccountAddressesRoute = AuthenticatedAccountAddressesRouteImport.update({
            id: '/addresses',path: '/addresses',getParentRoute: () => AuthenticatedAccountRoute
          })
const AuthenticatedAccountCouponsRoute = AuthenticatedAccountCouponsRouteImport.update({
            id: '/coupons',path: '/coupons',getParentRoute: () => AuthenticatedAccountRoute
          })
const AuthenticatedAccountOrdersRoute = AuthenticatedAccountOrdersRouteImport.update({
            id: '/orders',path: '/orders',getParentRoute: () => AuthenticatedAccountRoute
          })
const AuthenticatedAccountPrivacyRoute = AuthenticatedAccountPrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => AuthenticatedAccountRoute
          })
const AuthenticatedAccountReturnsRoute = AuthenticatedAccountReturnsRouteImport.update({
            id: '/returns',path: '/returns',getParentRoute: () => AuthenticatedAccountRoute
          })
const AuthenticatedAccountSecurityRoute = AuthenticatedAccountSecurityRouteImport.update({
            id: '/security',path: '/security',getParentRoute: () => AuthenticatedAccountRoute
          })
const AuthenticatedAccountWishlistRoute = AuthenticatedAccountWishlistRouteImport.update({
            id: '/wishlist',path: '/wishlist',getParentRoute: () => AuthenticatedAccountRoute
          })
const PSlugReviewRoute = PSlugReviewRouteImport.update({
            id: '/review',path: '/review',getParentRoute: () => PSlugRoute
          })





const AuthenticatedAccountRouteChildren = {
  AuthenticatedAccountAddressesRoute: AuthenticatedAccountAddressesRoute,AuthenticatedAccountCouponsRoute: AuthenticatedAccountCouponsRoute,AuthenticatedAccountOrdersRoute: AuthenticatedAccountOrdersRoute,AuthenticatedAccountPrivacyRoute: AuthenticatedAccountPrivacyRoute,AuthenticatedAccountReturnsRoute: AuthenticatedAccountReturnsRoute,AuthenticatedAccountSecurityRoute: AuthenticatedAccountSecurityRoute,AuthenticatedAccountWishlistRoute: AuthenticatedAccountWishlistRoute,AuthenticatedAccountIndexRoute: AuthenticatedAccountIndexRoute
}

const AuthenticatedAccountRouteWithChildren = AuthenticatedAccountRoute._addFileChildren(AuthenticatedAccountRouteChildren)



const AuthenticatedRouteChildren = {
  AuthenticatedAccountRoute: AuthenticatedAccountRouteWithChildren,AuthenticatedWishlistRoute: AuthenticatedWishlistRoute
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(AuthenticatedRouteChildren)




const PSlugRouteChildren = {
  PSlugReviewRoute: PSlugReviewRoute
}

const PSlugRouteWithChildren = PSlugRoute._addFileChildren(PSlugRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,AuthenticatedRoute: AuthenticatedRouteWithChildren,AboutRoute: AboutRoute,BackToSchoolRoute: BackToSchoolRoute,BestSellersRoute: BestSellersRoute,CartRoute: CartRoute,CheckoutRoute: CheckoutRoute,ChristmasRoute: ChristmasRoute,ContactRoute: ContactRoute,CookiesRoute: CookiesRoute,DataRequestRoute: DataRequestRoute,LoginRoute: LoginRoute,MrboxRoute: MrboxRoute,NewProductsRoute: NewProductsRoute,OffersRoute: OffersRoute,PandakiRoute: PandakiRoute,PaymentMethodsRoute: PaymentMethodsRoute,PrivacyRoute: PrivacyRoute,ResetPasswordRoute: ResetPasswordRoute,ReturnsRoute: ReturnsRoute,SearchRoute: SearchRoute,ShippingMethodsRoute: ShippingMethodsRoute,SignupRoute: SignupRoute,TermsRoute: TermsRoute,BrandIdRoute: BrandIdRoute,CSlugRoute: CSlugRoute,DevGamesRoute: DevGamesRoute,OrderTokenRoute: OrderTokenRoute,PSlugRoute: PSlugRouteWithChildren,PaymentFailureRoute: PaymentFailureRoute,PaymentSuccessRoute: PaymentSuccessRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)